/** Only the BFF's explicit member-session-expired outcome emits this signal. */
export const MEMBER_SESSION_EXPIRED_EVENT = 'omaplus:member-session-expired';

/** Inspect a clone; attachment consumers still own the response body. */
export async function observeMemberRestSessionExpiry(response: Response): Promise<void> {
  if (response.status !== 401) return;
  try {
    const body: unknown = await response.clone().json();
    if (
      typeof body === 'object' &&
      body !== null &&
      'error' in body &&
      body.error === 'member-session-expired' &&
      typeof window !== 'undefined'
    )
      window.dispatchEvent(new Event(MEMBER_SESSION_EXPIRED_EVENT));
  } catch {
    // The attachment's ordinary error handling owns malformed responses.
  }
}
